"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("./constants");

var _sx = _interopRequireDefault(require("./sx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Octicon({
  icon: IconComponent,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(IconComponent, rest);
}

Octicon.displayName = "Octicon";
const StyledOcticon = (0, _styledComponents.default)(Octicon).withConfig({
  displayName: "StyledOcticon",
  componentId: "uhnt7w-0"
})(["", " ", ""], _constants.COMMON, _sx.default);
StyledOcticon.defaultProps = {
  size: 16
};
var _default = StyledOcticon;
exports.default = _default;